module.exports = __webpack_public_path__ + "img/DE00096.35a13926.png";